import AbstractComponent from './components/AbstractComponent';

export default class Page {
  /**
   * Tests whether the page is loaded on a touch enabled device, or not.
   */
  public static readonly IS_TOUCH_DEVICE = window.matchMedia('( pointer: coarse )').matches;

  /**
   * The last stable page size.
   */
  private lastPageSize: { width: number, height: number };

  /**
   * The components that are active on the page.
   */
  private components: AbstractComponent[] = [];

  /**
   * Initializes the page.
   */
  constructor() {
    if (Page.IS_TOUCH_DEVICE) {
      document.body.classList.add('is-touch');
    }

    this.lastPageSize = {
      height: window.innerHeight,
      width: window.innerWidth,
    };

    // Attach a listener for when the window resized, but that is only called
    // when the new size of the window is stable.
    let resizeTimeout = undefined;

    window.addEventListener('resize', () => {
      if (resizeTimeout) {
        window.clearTimeout(resizeTimeout);
      }

      resizeTimeout = setTimeout(() => {
        this.onWindowResize()
      }, 200);
    });
  }

  /**
   * Adds a component to the page, and registers its animation scenes.
   *
   * @param component The component to add
   */
  public addComponent(component: AbstractComponent): void {
    component.initialize();

    this.components.push(component);
  }

  /**
   * Called when the window is resized and is stable.
   */
  private onWindowResize(): void {
    // Recreate the scenes for every component.
    this.components.forEach((component) => {
      component.onWindowResize(this.lastPageSize);
    });

    this.lastPageSize = {
      height: window.innerHeight,
      width: window.innerWidth,
    };
  }
}
